<template>
  	<div>
  		<div class="subheader position-relative">
			<h1 class="text-center text-white position-relative">
				{{ $t("not_found.title") }}
			</h1>
		</div>
	    <div class="bg-vanilla text-brown">
			<div class="container p-md-5 py-3">
				<div class="row">
					<div class="col-12 text-center">
						<h1>{{ $t("not_found.text") }}</h1>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {};
</script>


// WEBPACK FOOTER //
// src/components/404.vue